<script>
import { historicoAlteracoesGrv } from '../../../../domain/grv/services/index'

export default {
  name: 'MapaEdicoesGrv',
  props: {
    grvId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      historico: null,
      loading: true,
      erro: false
    }
  },
  mounted () {
    historicoAlteracoesGrv(this.grvId)
      .then(response => {
        this.historico = response.data
        this.loading = false
      })
      .catch(() => {
        this.erro = true
        this.loading = false
      })
  }
}
</script>

<template>
  <div class="mapa-edicoes">
    <div v-if="loading" class="text-center text-muted m-t m-b">
      <i class="fa fa-circle-o-notch fa-spin m-r-xs"></i> Carregando edições...
    </div>
    <div v-else-if="erro" class="text-center text-muted m-t m-b">
      Não foi possível carregar o histórico.
    </div>
    <div v-else-if="historico && historico.length === 0" class="text-center text-muted m-t m-b">
      Nenhuma edição de cadastro registrada para esta GRV.
    </div>
    <div v-else-if="historico" class="timeline-wrapper">
      <div
        v-for="(entry, idx) in historico"
        :key="entry.id"
        class="tl-entry"
      >
        <div class="tl-left">
          <div class="tl-dot"></div>
          <div class="tl-line" v-if="idx < historico.length - 1"></div>
        </div>
        <div class="panel panel-default tl-card">
          <div class="panel-body">
            <div class="tl-meta m-b-xs">
              <strong class="text-primary">
                <i class="fa fa-user-o m-r-xs"></i>{{ entry.username }}
              </strong>
              <span class="text-muted m-l-sm">
                <i class="fa fa-clock-o m-r-xs"></i>{{ entry.data }}
              </span>
            </div>
            <table class="table table-condensed table-striped m-n">
              <tbody>
                <tr v-for="alt in entry.alteracoes" :key="alt.campo">
                  <td class="tl-field-nome">{{ alt.campo }}</td>
                  <td><span class="label label-danger tl-val">{{ alt.de }}</span></td>
                  <td class="tl-seta text-muted">→</td>
                  <td><span class="label label-success tl-val">{{ alt.para }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mapa-edicoes {
  padding: 8px 4px;
  min-height: 60px;
}

.timeline-wrapper {
  padding: 4px 0;
}

.tl-entry {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.tl-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 14px;
  padding-top: 14px;
}

.tl-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #158CBA;
  flex-shrink: 0;
}

.tl-line {
  width: 2px;
  flex: 1;
  background: #d9edf7;
  margin-top: 4px;
  min-height: 16px;
}

.tl-card {
  flex: 1;
  margin-bottom: 10px;
  border-left: 3px solid #158CBA !important;
}

.tl-meta {
  font-size: 12px;
}

.tl-field-nome {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
  width: 160px;
}

.tl-seta {
  font-size: 12px;
  width: 20px;
  text-align: center;
}

.tl-val {
  font-size: 11px;
  font-weight: normal;
  max-width: 200px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.table-condensed > tbody > tr > td {
  padding: 3px 6px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// MapaEdicoesGrv.vue?46de9eee